import React, {useEffect, useMemo, useRef, useState} from 'react';
import {ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {Panel} from 'primereact/panel';
import {ScrollPanel} from 'primereact/scrollpanel';
import {Button} from "primereact/button";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import Spinner from "reactjs-simple-spinner";
import {Tooltip} from "primereact/tooltip";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import NhakaYanguService from "../../../services/NhakaYanguService";


function ViewPfumaAccountPage(props) {

    const InvestmentColumns = useMemo(
        () => [
            {
                header: 'Date',
                field: 'created_at',
            },
            {
                header: 'Policy Number',
                field: 'policy_number',
            },
            {
                header: 'Premium Payment',
                field: 'premium',
            },
            {
                header: 'Withdrawals',
                field: 'withdrawals',
            },
            {
                header: 'Price per Kg',
                field: 'beef_price'
            },
            {
                header: 'Kgs of Current Month',
                field: 'kgs_of_current_month'
            },
            {
                header: 'Investment Account Kgs',
                field: 'investment_account_kgs'
            },
            {
                header: 'Bonus Kgs at year end',
                field: 'bonus_kgs_at_year_end'
            },
            {
                header: 'Investment Account Kgs at year end',
                field: 'investment_account_kgs_at_year_end',
            },
            // {
            //     header: 'Investment Account Kgs at year end tracking',
            //     field: 'investment_account_kgs_at_year_end_monthEndCheck',
            // },
            {
                header: 'Investment Account Balance',
                field: 'investment_account_balance'
            }
        ],
        []
    )

    const InsuranceColumns = useMemo(
        () => [
            {
                header: 'Policy Number',
                field: 'policy_number',
            },
            {
                header: 'Monthly Cover Commencing',
                field: 'monthly_cover_commencing',
            },
            {
                header: 'Premium Payment',
                field: 'premium_payment',
            },
            {
                header: 'Withdrawals',
                field: 'withdrawals',
            },
            // {
            //     header: 'Hospital Kgs',
            //     field: 'hospital_kgs',
            // },
            // {
            //     header: 'Personal Accident Kgs',
            //     field: 'personal_accident_kgs',
            // },
            // {
            //     header: 'Funeral Kgs',
            //     field: 'funeral_kgs',
            // },
            // {
            //     header: 'Beef Price',
            //     field: 'beef_price',
            // },
            {
                header: 'Hospital $',
                field: 'hospital_cash_benefit'
            },
            {
                header: 'Personal Accident $',
                field: 'personal_accident_benefit'
            },
            {
                header: 'Funeral $',
                field: 'funeral_accident_benefit'
            },

        ],
        []
    )

    const [invData, setInvData] = useState([])
    const [insData, setInsData] = useState([])

    const [selectedInvData, setSelectedInvData] = useState([])
    const [selectedInsData, setSelectedInsData] = useState([])

    const dt = useRef(null);

    const exportInvColumns = InvestmentColumns.map(col => ({title: col.header, dataKey: col.field}));
    const exportInsColumns = InsuranceColumns.map(col => ({title: col.header, dataKey: col.field}));

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const exportInvPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportInvColumns, invData);
                doc.save('investment_account_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }

    const exportInsPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportInsColumns, insData);
                doc.save('insurance_account_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }


    const exportInvExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(invData);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'investment_account_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const exportInsExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(insData);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'insurance_account_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + EXCEL_EXTENSION);
            }
        });
    }

    const onInvSelectionChange = (e) => {
        setSelectedInvData(e.value);
    }

    const onInsSelectionChange = (e) => {
        setSelectedInsData(e.value);
    }

    const [loading, setLoading] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(false)
        let pN = JSON.parse(localStorage.getItem('policyNumber'));
        console.log("policy number: " + pN)
        NhakaYanguService.investmentAccount(pN)
            .then(res => {
                if (res.status == 200) {
                    console.log("success: ", res.data)
                    setInvData(res.data.investmentAccount)
                } else {
                    console.log("error: ", res)
                }
            }).catch(err => {
            console.log("error: ", err)
        })

        NhakaYanguService.insuranceAccount(pN)
            .then(res => {
                if (res.status == 200) {
                    console.log("success: ", res.data)
                    setInsData(res.data.InsuranceAccount)
                } else {
                    console.log("error: ", res)
                }
            }).catch(err => {
            console.log("error: ", err)
        })


    }, []);

    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportInvExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportInvPdf}
                    className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    const InsHeader = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportInsExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportInsPdf}
                    className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    const invFilters = {
        'created_at': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        }

    }

    const insFilters = {
        'cover_commencing_date': {
            operator: FilterOperator.OR,
            constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
        }

    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to={'/view-ilifa'}><i className="fa fa-backward"/> Back</Link>    &nbsp;|
                            Pfuma Account For Policy &nbsp;<span
                            className="text-primary font-weight-bold">{JSON.parse(localStorage.getItem('policyNumber'))}</span>
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row">

                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="content-panel p-1">
                                        <div className="card flex justify-content-center">
                                            <Panel header="Investment Account" toggleable>
                                                <ScrollPanel style={{width: '100%', height: '350px'}}>
                                                    <Tooltip target=".export-buttons>button" position="bottom"/>
                                                    <DataTable value={invData} responsiveLayout="scroll" header={header}
                                                               paginator
                                                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                               rowsPerPageOptions={[5, 10, 25, 50]}
                                                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                               rows={5}
                                                               sortMode="multiple" filters={invFilters}
                                                               filterDisplay="menu"
                                                               resizableColumns
                                                               ref={dt}
                                                               dataKey="id"
                                                               scrollable scrollHeight="600px"
                                                               selection={selectedInvData}
                                                               onSelectionChange={onInvSelectionChange}
                                                               selectionMode="checkbox">
                                                        <Column selectionMode="multiple"/>
                                                        <Column field="created_at" header="Date" filter
                                                                style={{minWidth: '4rem'}}></Column>
                                                        <Column field="premium" header="Premium Payment"
                                                                style={{minWidth: '12rem'}}></Column>
                                                        <Column field="withdrawals" style={{minWidth: '4rem'}}
                                                                header="Withdrawals"></Column>
                                                        <Column field="beef_price" style={{minWidth: '4rem'}}
                                                                header="Price per Kg"
                                                        ></Column>
                                                        <Column field="kgs_of_current_month" style={{minWidth: '12rem'}}
                                                                header="Kgs of Current Month"></Column>
                                                        <Column field="investment_account_kgs"
                                                                style={{minWidth: '12rem'}}
                                                                header="Investment Account Kgs"></Column>
                                                        <Column field="bonus_kgs_at_year_end"
                                                                style={{minWidth: '18rem'}}
                                                                header="Bonus Kgs At Year End"></Column>
                                                        <Column field="investment_account_kgs_at_year_end"
                                                                style={{minWidth: '18rem'}}
                                                                header="Investment Account Kgs At Year End"></Column>
                                                        {/*<Column field="investment_account_kgs_at_year_end_monthEndCheck"*/}
                                                        {/*        style={{minWidth: '20rem'}}*/}
                                                        {/*        header="Investment Account Kgs At Year End Track"></Column>*/}
                                                        <Column field="investment_account_balance"
                                                                style={{minWidth: '18rem'}}
                                                                header="Investment Account Balance"></Column>
                                                    </DataTable>
                                                </ScrollPanel>
                                            </Panel>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="content-panel p-1">
                                        <div className="card flex justify-content-center">
                                            <Panel header="Insurance Account" toggleable>
                                                <ScrollPanel style={{width: '100%', height: '350px'}}>
                                                    <Tooltip target=".export-buttons>button" position="bottom"/>
                                                    <DataTable value={insData} responsiveLayout="scroll"
                                                               header={InsHeader}
                                                               paginator
                                                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                               rowsPerPageOptions={[5, 10, 25, 50]}
                                                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                               rows={5}
                                                               sortMode="multiple" filters={insFilters}
                                                               filterDisplay="menu"
                                                               resizableColumns
                                                               ref={dt}
                                                               dataKey="id"
                                                               scrollable scrollHeight="600px"
                                                               selection={selectedInsData}
                                                               onSelectionChange={onInsSelectionChange}
                                                               selectionMode="checkbox">
                                                        <Column selectionMode="multiple"/>
                                                        <Column field="monthly_cover_commencing"
                                                                header="Monthly Cover Commencing"
                                                                filter style={{minWidth: '12rem'}}></Column>
                                                        <Column field="premium_payment"
                                                                header="Premium Payment"
                                                                filter style={{minWidth: '6rem'}}></Column>
                                                        <Column field="withdrawals"
                                                                header="Withdrawals"
                                                                filter style={{minWidth: '12rem'}}></Column>
                                                        {/*<Column field="hospital_kgs" header="Hospital Kgs"*/}
                                                        {/*        style={{minWidth: '12rem'}}></Column>*/}
                                                        {/*<Column field="personal_accident_kgs" style={{minWidth: '8rem'}}*/}
                                                        {/*        header="Personal Accident Kgs"></Column>*/}
                                                        {/*<Column field="funeral_kgs" style={{minWidth: '8rem'}}*/}
                                                        {/*        header="Funeral Kgs"*/}
                                                        {/*></Column>*/}
                                                        {/*<Column field="beef_price" style={{minWidth: '4rem'}}*/}
                                                        {/*        header="Beef Price"*/}
                                                        {/*></Column>*/}
                                                        <Column field="hospital_cash_benefit" style={{minWidth: '12rem'}}
                                                                header="Hospital Cash Benefit"></Column>
                                                        <Column field="personal_accident_benefit"
                                                                style={{minWidth: '12rem'}}
                                                                header="Personal Accident Benefit"></Column>
                                                        <Column field="funeral_accident_benefit" style={{minWidth: '12rem'}}
                                                                header="Funeral Cash Benefit"></Column>
                                                    </DataTable>
                                                </ScrollPanel>
                                            </Panel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewPfumaAccountPage;
